import { useEffect, useMemo, useState } from 'react'
import GminaService from '@/services/GminaService'

function formatGminaLabel(item) {
	const gminaName = item?.nazwa || '-'
	const powiatName = item?.id_powiat?.nazwa || item?.id_miasto?.id_powiat?.nazwa || ''
	const wojewodztwoName =
		item?.id_wojewodztwo?.nazwa || item?.id_powiat?.id_wojewodztwo?.nazwa || item?.id_miasto?.id_powiat?.id_wojewodztwo?.nazwa || ''

	const locationParts = [powiatName, wojewodztwoName].filter(Boolean)
	return locationParts.length > 0 ? `${gminaName} (${locationParts.join(', ')})` : gminaName
}

export default function useGminaFilterModal(isOpen, selectedGminaId, idPowiat = null, idWojewodztwo = null) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedGminaId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedGminaId || '')
	}, [isOpen, selectedGminaId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const filters = {}
			if (idPowiat) filters.id_powiat = idPowiat
			if (idWojewodztwo) filters.id_wojewodztwo = idWojewodztwo
			const options = {
				limit: 200,
				sortColumn: 'nazwa',
				sortDirection: 'asc',
				filters,
			}
			const result = query ? await GminaService.search(query, options) : await GminaService.getAll(options)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm, idPowiat, idWojewodztwo])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected ? formatGminaLabel(selected) : ''
	}, [items, activeId])

	return {
		searchTerm,
		setSearchTerm,
		items,
		loading,
		error,
		activeId,
		setActiveId,
		selectedName,
		labelAccessor: formatGminaLabel,
		clearFilter: () => setActiveId(''),
	}
}
